import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { getClockState, TimesheetService } from './../../../reducers/orm/timesheet/timesheet.service';
import { showClockSwitch } from './sb-header.selectors';

@Injectable({
  providedIn: 'root',
})
export class SBHeaderService {
  private store = inject<Store<AppState>>(Store);
  private timesheetService = inject(TimesheetService);

  supervisorRequestsSidebarOpen$ = new BehaviorSubject<boolean>(false);

  myRequestsSidebarOpen$ = new BehaviorSubject<boolean>(false);

  profileDropdownOpen$ = new BehaviorSubject<boolean>(false);

  toggleProfileDropdownOpen() {
    const current = this.profileDropdownOpen$.getValue();
    this.profileDropdownOpen$.next(!current);
  }

  clockState$ = this.timesheetService.loadClockState().pipe(switchMap(() => this.store.select(getClockState)));

  showSwitchButton$ = this.store.select(showClockSwitch);
}
